import React, { useState } from 'react';
import { Page, NotifyModal, ModalAlert } from 'components';
import { Form } from './components';
import Header from 'components/Header/Header';
import { useHistory } from 'react-router-dom';

import ApiMServer from 'services/ApiMServer';

const UnitsAdd = () => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.cooperatives?.write !== true) {
    window.location.replace('/home');
  }

  const { permission } = JSON.parse(localStorage.getItem('userData'));

  const [units, setUnits] = useState({
    name: '',
    cnpj: '',
    fone: '',
    email: '',
    ncontract: '',
    typeCompany: true
  });

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [message, setMessage] = useState("");

  const handleModalAlert = (msg) => {
    setMessage(msg);
    setShowModalAlert(true)
  }

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setUnits(values => ({
      ...values,
      [field]: value
    }));
  };

  const updateAddressAndLocation = (newAddress, newLat, newLng) => {
    setUnits(prevUnits => ({
      ...prevUnits,
      address: newAddress,
      location: {
        lat: String(newLat),
        lng: String(newLng)
      }
    }));
  };

const validateCpfOrCnpj = (value) => {
  const digits = value.replace(/[^\d]+/g, '');

  if (digits.length === 11) {
    // Validação de CPF
    if (/^(\d)\1+$/.test(digits)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(digits.charAt(i)) * (10 - i);
    }
    let rest = 11 - (sum % 11);
    let digit1 = rest >= 10 ? 0 : rest;
    if (digit1 !== parseInt(digits.charAt(9))) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(digits.charAt(i)) * (11 - i);
    }
    rest = 11 - (sum % 11);
    let digit2 = rest >= 10 ? 0 : rest;
    if (digit2 !== parseInt(digits.charAt(10))) return false;

    return true;

  } else if (digits.length === 14) {
    // Validação de CNPJ
    if (/^(\d)\1+$/.test(digits)) return false;

    let length = digits.length - 2;
    let numbers = digits.substring(0, length);
    let digitsVerifiers = digits.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digitsVerifiers.charAt(0))) return false;

    length += 1;
    numbers = digits.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digitsVerifiers.charAt(1))) return false;

    return true;
  }

  return false; // Não é CPF nem CNPJ válido
};

  const validateEmail = (email) => {
    // Regex simples para validação de e-mail
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validatePhone = (fone) => {
    // Aceita formatos (xx) xxxxx-xxxx ou (xx) xxxx-xxxx
    return /^(\(\d{2}\)\s?|\d{2})\d{4,5}-?\d{4}$/.test(fone);
  };

  const handleSubmit = async () => {
    try {
      if (!units.name || units.name.trim() === '') {
        handleModalAlert('Preencha o Campo "Nome da Cooperativa"');
        return
      }

      if (!units.cnpj || units.cnpj.trim() === '') {
        handleModalAlert('Preencha o campo "CNPJ"');
        return
      }

      if (!validateCpfOrCnpj(units.cnpj)) {
        handleModalAlert('CNPJ inválido.');
        return
      }

      if (!units.address || (typeof units.address === 'string' && units.address.trim() === '')) {
        handleModalAlert('Preencha o campo "Endereço"');
        return
      }

      if (!units.ncontract || units.ncontract.trim() === '') {
        handleModalAlert('Preencha o campo "Número do contrato"');
        return
      }

      if (units.ncontract.length < 10) {
        handleModalAlert("O campo 'Número do contrato' deve ser preenchido completamente.");
        return
      }

      if (!units.fone || units.fone.trim() === '') {
        handleModalAlert('Preencha o campo "Telefone"');
        return
      }

      if (!validatePhone(units.fone)) {
        handleModalAlert('Telefone inválido. Use o formato (xx) xxxxx-xxxx ou (xx) xxxx-xxxx.');
        return
      }

      if (!units.email || units.email.trim() === '') {
        handleModalAlert('Preencha o campo "E-mail"');
        return
      }

      if (!validateEmail(units.email)) {
        handleModalAlert('E-mail inválido.');
        return
      }

      const { data } = await ApiMServer.post('/company/create', units);

      handleAlertModalSuccess("Adicionado com sucesso!");
      setUnits({
        name: '',
        cnpj: '',
        fone: '',
        email: '',
        ncontract: '',
        typeCompany: true
      });

      setTimeout(() => {
        history.push(`/cooperatives/${data._id}`);
      }, 1200);

    } catch (e) {
      handleAlertModalError('Falha ao adicionar!');
    }
  };

  return (
    <Page className="p-3" title="Cooperativas">

      <Header page={'Adicionar Cooperativas'} />

      <ModalAlert
        message={message}
        showModalAlert={showModalAlert}
        onHide={() => setShowModalAlert(false)}
      />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Form
        permission={permission}
        fieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        units={units}
        setLocation={updateAddressAndLocation}
      />

    </Page>
  );
};

export default UnitsAdd;
